module.exports = __webpack_public_path__ + "img/1.d45a6762.png";